module.exports = __webpack_public_path__ + "static/img/pair-dice.562e6d19.svg";